import * as state from './state';
import * as getters from './getters';
import mutations from './mutations';
import actions from './actions';

export default {
    namespaced: true,
    state: () => state.state,
    getters,
    mutations,
    actions,
};
